import { installBenignErrorFilters } from './utils/abortError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

installBenignErrorFilters();

const origFetch = window.fetch.bind(window);
window.fetch = async function(input, init) {
  const res = await origFetch(input, init);
  if (res.status === 401) {
    const url = typeof input === 'string' ? input : (input instanceof Request ? input.url : '');
    if (!url.includes('/api/auth/')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const path = window.location.pathname;
      if (path.includes('/admin')) window.location.href = '/admin/login';
      else if (path.includes('/rider')) window.location.href = '/rider/login';
      else if (path.includes('/merchant')) window.location.href = '/m/login';
      else window.location.href = '/login';
      throw new Error('انتهت صلاحية الجلسة');
    }
  }
  return res;
};
const root = ReactDOM.createRoot(document.getElementById('root'));

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
